import { render, staticRenderFns } from "./FormBlock.vue?vue&type=template&id=05df6ac4&"
import script from "./FormBlock.vue?vue&type=script&lang=js&"
export * from "./FormBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports